/* Presentation adapter for Nitro's existing Wishlist (bee_wis). No second store. */
(() => {
  if (window.kmFavoritesAdapter) return;
  window.kmFavoritesAdapter = true;
  const heart = '<svg class="km-heart-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  function ids() {
    try { return new Set((localStorage.getItem('bee_wis') || '').split(',').filter(x => /^id:\d+$/.test(x)).map(x => x.slice(3))); }
    catch { return null; }
  }
  const setAttr = (el, key, value) => { if (el.getAttribute(key) !== value) el.setAttribute(key, value); };
  function sync() {
    const saved = ids();
    if (!saved || !window.BEEThemeSP?.Wishlist || window.BEEconfigs?.wishlist_mode !== '1') return;
    document.querySelectorAll('[data-count-wishlist]').forEach(counter => {
      if (counter.textContent !== String(saved.size)) counter.textContent = String(saved.size);
    });
    document.querySelectorAll('.bee-product[data-product-options]').forEach(card => {
      const image = card.querySelector('.bee-product-image');
      if (!image) return;
      let options;
      try { options = JSON.parse(card.getAttribute('data-product-options')); } catch { return; }
      if (!/^\d+$/.test(String(options.id))) return;
      const buttons = Array.from(card.querySelectorAll('[data-action-wishlist], [data-remove-wishlist]'));
      let button = buttons.shift();
      // Reuse the native delegated event hooks, including cards without a placeholder.
      if (!button) {
        button = document.createElement('a');
        button.href = card.querySelector('a[href*="/products/"]')?.href || '#';
        button.className = 'bee-pr-item-btn bee-pr-wishlist';
        button.dataset.id = String(options.id);
        button.setAttribute(window.isPageWishlist ? 'data-remove-wishlist' : 'data-action-wishlist', '');
        button.innerHTML = '<span class="bee-svg-pr-icon">' + heart + '</span>';
      }
      buttons.forEach(extra => extra.remove());
      if (!button.classList.contains('km-card-heart')) button.classList.add('km-card-heart');
      if (button.parentElement !== image) image.append(button);
      button.removeAttribute('data-tooltip');
      const icon = button.querySelector('.bee-svg-pr-icon');
      if (icon && !icon.querySelector('.km-heart-svg')) icon.innerHTML = heart;
      const selected = saved.has(String(options.id));
      if (button.classList.contains('is--added') !== selected) button.classList.toggle('is--added', selected);
      setAttr(button, 'role', 'button');
      setAttr(button, 'aria-pressed', String(selected));
      const name = card.querySelector('.bee-product-title')?.textContent.trim() || 'Ürün';
      setAttr(button, 'aria-label', name + (selected ? ': favorilerden çıkar' : ': favorilere ekle'));
      if (options.available === false && !card.querySelector('.km-favorite-stock') && window.isPageWishlist) {
        const stock = document.createElement('p');
        stock.className = 'km-favorite-stock'; stock.textContent = 'Stokta yok';
        card.querySelector('.bee-product-info')?.append(stock);
      }
    });
    const bar = document.querySelector('.km-five-toolbar');
    if (bar?.querySelectorAll('.bee-toolbar-item').length === 5 && window.BEEThemeSP?.Drawer) document.documentElement.classList.add('km-five-nav-ready');
  }
  let pending = false;
  function schedule() { if (pending) return; pending = true; requestAnimationFrame(() => { pending = false; sync(); }); }
  function init() {
    sync();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
    // Space is not a native activation key for anchors; Nitro owns the click itself.
    document.addEventListener('keydown', event => {
      if (event.key === ' ' && event.target.closest('.km-card-heart')) { event.preventDefault(); event.target.closest('.km-card-heart').click(); }
    });
    document.addEventListener('click', event => { if (event.target.closest('[data-action-wishlist], [data-remove-wishlist]')) schedule(); });
    document.addEventListener('click', event => {
      if (!event.target.closest('[data-action-wishlist], [data-remove-wishlist]')) return;
      try {
        const current = localStorage.getItem('bee_wis');
        if (current === null) { localStorage.setItem('bee_wis', ''); localStorage.removeItem('bee_wis'); }
        else localStorage.setItem('bee_wis', current);
      } catch {
        event.preventDefault(); event.stopImmediatePropagation();
        let status = document.querySelector('#km-favorites-status');
        if (!status) { status = document.createElement('p'); status.id = 'km-favorites-status'; status.setAttribute('role', 'alert'); document.body.append(status); }
        status.textContent = 'Tarayıcı depolaması kapalı. Favoriler kaydedilemiyor.';
      }
    }, true);
    window.addEventListener('pageshow', event => {
      // A bfcache restore can return to the DOM of an open drawer. Reuse Nitro's
      // close handlers rather than changing its state/classes or rebinding it.
      if (event.persisted) {
        if (document.querySelector('.bee-drawer[aria-hidden="false"]')) window.BEEThemeSP?.Drawer?.close();
        document.querySelector('.bee-dropdown__wrapper.is--opened [data-dropdown-close]')?.click();
        document.querySelector('.bee-modal__inner [data-bee-modal-close]')?.click();
      }
      schedule();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
